import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { AdobeDataLayerT } from '@consumer-frontend/nc-utils';

import { ApiClientAppT, apiEndpoints } from '../lib';
import { applyFetchers, dashboardFetchers } from '../lib/swrConfig';

export const useAdobeDataLayer = (accountId: string, variant: ApiClientAppT = 'dashboard') => {
  const fetcher = variant === 'apply' ? applyFetchers.get : dashboardFetchers.get;

  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<AdobeDataLayerT, AxiosError>(
    () => (accountId ? apiEndpoints.dashboard.adobeDataLayer(accountId) : null),
    fetcher,
  );

  return {
    adobeDataLayer: data,
    error,
    isLoading,
  };
};
